import { render, staticRenderFns } from "./WBtnArchive.vue?vue&type=template&id=742106d0&scoped=true&"
import script from "./WBtnArchive.vue?vue&type=script&setup=true&lang=js&"
export * from "./WBtnArchive.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742106d0",
  null
  
)

export default component.exports